import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { offer } from '../data/offer';
export function Close() {
  return <section className="w-full border-y-4 border-shuttle bg-court-deep" data-id="element-55" data-mp="1zvbdssjy911c">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-56" data-mp="1uwrs8t99pr9i">
        <h2 className="font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-57" data-mp="1q01ck71dkxom">
          Stop improvising.{' '}
          <span className="text-shuttle" data-id="element-58" data-mp="1l29ojo3upvpp">Start coaching from a plan.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/85" data-id="element-59" data-mp="1g85e2uvdn5jv">
          Grip and serve, backcourt, frontcourt, movement, doubles, match play.
          Written, sequenced, printable.
        </p>

        <div className="mt-7" data-id="element-60" data-mp="17alavgdyez6m">
          <Countdown size="sm" tone="dark" data-id="element-61" data-mp="129e3vjjmy410" />
        </div>

        <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-2xl border border-shuttle bg-white/10 px-5 py-4 text-left" data-id="element-62" data-mp="128vynxezwfgy">
          <div data-id="element-63" data-mp="3vf55da91kqsj">
            <span className="block text-[10px] font-bold uppercase tracking-widest text-shuttle" data-id="element-64" data-mp="3ven41z7ivmdr">
              Complete pack
            </span>
            <span className="text-[15px] font-bold text-white" data-id="element-65" data-mp="3lh8yiun50i08">
              Badminton Class Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <div className="flex items-baseline gap-2.5" data-id="element-66" data-mp="3qh3moqfj2thl">
            <span className="text-[15px] text-white/60 line-through" data-id="element-67" data-mp="i0s591nlafma">${offer.anchor}</span>
            <span className="font-display text-4xl font-extrabold leading-none text-white" data-id="element-68" data-mp="mzll30qcmipm">
              ${offer.price}
            </span>
          </div>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-69" data-mp="822sfnajvlcw">
          <CtaButton data-id="element-70" data-mp="d0w7hk5hjkf6">Yes, plan my season — ${offer.price}</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/75" data-id="element-71" data-mp="2sstluerhabs2">
          {['Secure checkout', 'Instant access', `${offer.guaranteeDays}-day guarantee`].map(item => <li key={item} className="flex items-center gap-2" data-id="element-72" data-mp="149fnm1vretq7">
              <span className="h-1.5 w-1.5 rounded-full bg-shuttle" data-id="element-73" data-mp="14b0g7lyik2lf" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}